// ============================================
// ЛИНИЯ ТОЧНО ПО ЦЕНТРУ ЦИФР (ЧЕРЕЗ JS)
// ============================================

document.addEventListener('DOMContentLoaded', function() {
    const stepsContainer = document.querySelector('.process__steps');
    if (!stepsContainer) return;

    // Находим все цифры
    const numbers = stepsContainer.querySelectorAll('.process-step__number');
    if (numbers.length === 0) return;

    // Создаём линию
    const line = document.createElement('div');
    line.className = 'process__line-js';
    stepsContainer.style.position = 'relative';
    stepsContainer.appendChild(line);

    // Функция обновления позиции линии
    function updateLinePosition() {
        const firstNumber = numbers[0];
        const lastNumber = numbers[numbers.length - 1];

        if (!firstNumber || !lastNumber) return;

        const containerRect = stepsContainer.getBoundingClientRect();
        const firstRect = firstNumber.getBoundingClientRect();
        const lastRect = lastNumber.getBoundingClientRect();

        // Центр цифры (середина по X)
        const centerX = firstRect.left + firstRect.width / 2 - containerRect.left;

        // Высота линии: от верха первой цифры до низа последней
        const topY = firstRect.top - containerRect.top;
        const bottomY = lastRect.bottom - containerRect.top;

        // Применяем
        line.style.left = centerX + 'px';
        line.style.top = topY + 'px';
        line.style.height = (bottomY - topY) + 'px';
    }

    // Обновляем при загрузке и при изменении размера окна
    updateLinePosition();
    window.addEventListener('resize', updateLinePosition);

    // Обновляем после любых изменений (на случай, если контент подгружается)
    const observer = new MutationObserver(function() {
        updateLinePosition();
    });
    observer.observe(stepsContainer, { childList: true, subtree: true, attributes: true });
});
